import { Image } from "antd";
const PageNotFound = () => {
	return (
		<Image preview={false} src="/img/404.png" width={"100%"} height={"100%"} />
	);
};
export { PageNotFound };
